import {
  Grid,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  CircularProgress,
} from '@mui/material'
import { useCallback, useContext, useEffect, useState } from 'react'
import { metodoPrograma } from '../../../../components/api'
import { GlobalContext } from '../../../../App'
import { Eye, Trash } from 'lucide-react'
import { ArrowBack } from '@mui/icons-material'
import { setError } from '../../../../components/alerts'
import { InputMedicamento } from './InputMedicamento'
import { InputViaAdministracao } from './InputViaAdministracao'
import { BsFileEarmarkMedical, BsFileEarmarkMedicalFill } from 'react-icons/bs'
import { GiMedicalPack } from 'react-icons/gi'
import { FaRegSave } from 'react-icons/fa'

export const Receituario = ({ atendimentoSelecionado }) => {
  const { agenda } = useContext(GlobalContext)
  const [adicionaDocumento, setAdicionaDocumento] = useState(false)
  const [observacao, setObservacao] = useState('')
  const [tipo, setTipo] = useState(undefined)
  const [isLoading, setIsLoading] = useState(false)
  const [medicamento, setMedicamento] = useState({
    nmMedicamento: '',
    idVia: 0,
    forma: '',
    quantidade: '',
    observacao: '',
  })
  const [lista, setLista] = useState([])
  const [listaMedicamentos, setListaMedicamentos] = useState([])

  function adicionaMedicamento() {
    if (medicamento.nmMedicamento === '' || medicamento.quantidade === '')
      return
    setListaMedicamentos((state) => [
      ...state,
      {
        nmMedicamento: medicamento.nmMedicamento,
        idVia: medicamento.idVia,
        forma: medicamento.forma,
        quantidade: medicamento.quantidade,
        observacao: medicamento.observacao,
      },
    ])
    setMedicamento({
      nmMedicamento: '',
      idVia: 0,
      forma: '',
      quantidade: '',
      observacao: '',
    })
  }

  function addReceituario(tipoReceituario) {
    setTipo(tipoReceituario)
    setAdicionaDocumento(true)
  }

  function removeMedicamento(index) {
    setListaMedicamentos((state) => state.filter((_, i) => i !== index))
  }

  function salvaReceituarioPaciente() {
    if (listaMedicamentos.length === 0) {
      setError('Adicione pelo menos um medicamento')
      return
    }
    setIsLoading(true)
    metodoPrograma('salvaReceituarioPaciente', {
      idAgenda: agenda[0],
      tpReceituario: tipo,
      idPaciente: atendimentoSelecionado.dadosAtendimento[7].idPaciente,
      idAgendamento: atendimentoSelecionado.dadosAtendimento[0],
      dsObservacao: observacao,
      itensReceituario: listaMedicamentos,
    }).then((response) => {
      if (response.status) {
        setObservacao('')
        setAdicionaDocumento(false)
        setMedicamento({
          nmMedicamento: '',
          idVia: 0,
          forma: '',
          quantidade: '',
          observacao: '',
        })
        setListaMedicamentos([])
        getListaDocumentos()
        window.open(response.urlDocumentoAssinado)
      }
      setIsLoading(false)
    })
  }

  const getListaDocumentos = useCallback(() => {
    metodoPrograma('listaDocumentoPaciente', {
      tpDocumento: 'R',
      idAgenda: agenda[0],
      idPaciente: atendimentoSelecionado.dadosAtendimento[7].idPaciente,
      idAgendamento: atendimentoSelecionado.dadosAtendimento[0],
    }).then((response) => {
      if (response.status) {
        setLista(response.lista)
      }
    })
  }, [agenda, atendimentoSelecionado.dadosAtendimento])

  useEffect(() => {
    getListaDocumentos()
  }, [getListaDocumentos])

  return (
    <Grid item xs={12}>
      {!adicionaDocumento && (
        <>
          <Grid container spacing={1}>
            <Grid item xs={6}></Grid>
            <Grid item xs={3}>
              <Button
                variant="contained"
                default
                fullWidth
                onClick={() => addReceituario('S')}
              >
                <BsFileEarmarkMedicalFill
                  style={{
                    fontSize: '20px',
                    marginBottom: 5,
                    marginTop: 5,
                    marginRight: 20,
                  }}
                />
                Receituário simples
              </Button>
            </Grid>
            <Grid item xs={3}>
              <Button
                variant="contained"
                fullWidth
                onClick={() => addReceituario('E')}
              >
                <BsFileEarmarkMedical
                  style={{
                    fontSize: '20px',
                    marginBottom: 5,
                    marginTop: 5,
                    marginRight: 20,
                  }}
                />
                Receituário ESPECIAL
              </Button>
            </Grid>
          </Grid>
          {lista?.length > 0 ? (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Tipo</TableCell>
                  <TableCell>Data</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>

              <TableBody>
                {lista.map((item) => (
                  <TableRow key={item[0]}>
                    <TableCell>{item[1]}</TableCell>
                    <TableCell>{item[2]}</TableCell>
                    <TableCell>
                      <div className="flex gap-3 justify-end">
                        {item[3] && (
                          <IconButton
                            size="small"
                            onClick={() => window.open(item[3])}
                          >
                            <Eye size={18} />
                          </IconButton>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '14px 16px',
                borderRadius: 10,
                backgroundColor: '#f6f8fa',
                border: '1px solid #e5e7eb',
                color: '#6b7280',
              }}
            >
              <div
                style={{
                  fontSize: 20,
                  lineHeight: 1,
                }}
              >
                💊
              </div>

              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontSize: 14, fontWeight: 500 }}>
                  Nenhum receituário encontrado
                </span>

                <span style={{ fontSize: 12, color: '#9ca3af' }}>
                  Ainda não existem receituários cadastrados para este paciente.
                </span>
              </div>
            </div>
          )}
        </>
      )}
      {adicionaDocumento && (
        <>
          <div className="p-5 border-2">
            <h3>Medicamentos</h3>
            {listaMedicamentos.length > 0 && (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Nome</TableCell>
                    <TableCell>Administração</TableCell>
                    <TableCell>Quantidade</TableCell>
                    <TableCell>Observação</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listaMedicamentos.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.nmMedicamento}</TableCell>
                      <TableCell>{item.forma}</TableCell>
                      <TableCell>{item.quantidade}</TableCell>
                      <TableCell>{item.observacao}</TableCell>
                      <TableCell align="right">
                        <IconButton
                          size="small"
                          onClick={() => removeMedicamento(index)}
                        >
                          <Trash size={18} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <InputMedicamento {...{ medicamento, setMedicamento }} />
              </Grid>
              <Grid item xs={12} sm={3} md={3} lg={3}>
                <InputViaAdministracao {...{ medicamento, setMedicamento }} />
              </Grid>
              <Grid item xs={12} sm={3} md={3} lg={3}>
                <TextField
                  variant="outlined"
                  margin="dense"
                  label="Quantidade"
                  value={medicamento.quantidade}
                  fullWidth
                  onChange={(e) =>
                    setMedicamento({
                      ...medicamento,
                      quantidade: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <TextField
                  variant="outlined"
                  margin="dense"
                  label="Observações"
                  value={medicamento.observacao}
                  fullWidth
                  onChange={(e) =>
                    setMedicamento({
                      ...medicamento,
                      observacao: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={adicionaMedicamento}
                >
                  <GiMedicalPack
                    style={{
                      fontSize: '20px',
                      marginBottom: 5,
                      marginTop: 5,
                      marginRight: 20,
                    }}
                  />
                  Adicionar
                </Button>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <h3>Observações Gerais</h3>
                <TextField
                  variant="outlined"
                  margin="dense"
                  label="Observações Gerais"
                  value={observacao}
                  fullWidth
                  onChange={(e) => setObservacao(e.target.value)}
                />
              </Grid>
            </Grid>
          </div>
          <div
            style={{
              marginTop: '10px',
              display: 'flex',
              justifyContent: 'end',
              gap: '10px',
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                setAdicionaDocumento(false)
                setMedicamento({
                  nmMedicamento: '',
                  quantidade: '',
                  observacao: '',
                })
                setListaMedicamentos([])
                getListaDocumentos()
              }}
              startIcon={<ArrowBack />}
            >
              Cancelar
            </Button>
            <Button
              disabled={isLoading}
              endIcon={isLoading ? <CircularProgress size={20} /> : null}
              variant="contained"
              color="primary"
              onClick={salvaReceituarioPaciente}
              startIcon={<FaRegSave />}
            >
              Salvar
            </Button>
          </div>
        </>
      )}
    </Grid>
  )
}
